<ng-container *ngFor="let key of complimentaryConfigurationKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: complimentaryConfigurationLookup : complimentaryConfigurationWithLookup[key] ?? null"
  ></div>
</ng-container>
